export const assertRef = <T extends abstract new (...args: any[]) => any>(
  ref: any,
  component: T,
) => ref as InstanceType<typeof component>;

export const assertRefArray = <T extends abstract new (...args: any[]) => any>(
  ref: any,
  component: T,
) => {
  if (!Array.isArray(ref)) {
    throw new Error('assertRefArray: passed ref is not an array');
  }

  return ref as InstanceType<typeof component>[];
};
